import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

import type { IncomingCallData } from "../../utils/incomingCallEvent";

interface IncomingCallsState {
  isOpen: boolean;
  incomingCallsList: IncomingCallData[] | null;
}

const initialState: IncomingCallsState = {
  isOpen: false,
  incomingCallsList: [],
};

const incomingCallsSlice = createSlice({
  name: "incomingCalls",
  initialState,
  reducers: {
    addNewIncomingCallData: (
      state,
      action: PayloadAction<IncomingCallData>
    ) => {
      state.isOpen = true;
      if (state.incomingCallsList) {
        const existingCallIndex = state.incomingCallsList.findIndex(
          (call) => call.id === action.payload.id
        );
        if (existingCallIndex >= 0) {
          state.incomingCallsList[existingCallIndex] = {
            ...state.incomingCallsList[existingCallIndex],
            ...action.payload,
          };
        } else {
          state.incomingCallsList.unshift(action.payload);
        }
      } else {
        state.incomingCallsList = [action.payload];
      }
    },
    updateIncomingCallData: (
      state,
      action: PayloadAction<{
        id: string;
        status: string;
      }>
    ) => {
      if (state.incomingCallsList) {
        state.incomingCallsList = state.incomingCallsList.map((call) =>
          call.id === action.payload.id
            ? { ...call, ...action.payload }
            : call
        );
      }
    },
    deleteIncomingCallData: (
      state,
      action: PayloadAction<{
        id: string;
      }>
    ) => {
      if (state.incomingCallsList) {
        state.incomingCallsList = state.incomingCallsList.filter(
          (call) => call.id !== action.payload.id
        );
      }
    },
    closeIncomingCalls: (state) => {
      state.isOpen = false;
      //   state.callData = [];
    },
    openIncomingCalls: (state) => {
      state.isOpen = true;
      //   state.callData = [];
    },
  },
});

export const {
  addNewIncomingCallData,
  closeIncomingCalls,
  openIncomingCalls,
  deleteIncomingCallData,
  updateIncomingCallData
} = incomingCallsSlice.actions;
export default incomingCallsSlice.reducer;
